<script setup lang="ts">
import { computed } from "vue";
import { RouterLink, useRouter } from "vue-router";
import { TabsContent, TabsIndicator, TabsList, TabsRoot, TabsTrigger } from "reka-ui";

import { useRootLayout } from "@/hooks/use-root-layout";

import { useBrandStore } from "@/stores";

import { $can } from "@/services/UtilitiesService";

const router = useRouter();
const brandStore = useBrandStore();
const { headerRef } = useRootLayout();

const brand = computed(() => brandStore.selectedBrand);

const tabs = computed(() =>
  [
    { title: "Case Search", name: "brand" },
    {
      title: "Case History",
      name: "brandhistory",
      show: brandStore.featuresConfig.caseHistory === "enabled" && $can("useCaseHistory"),
    },
    { title: "Audit", name: "brandaudit", show: $can("viewAudit") },
    { title: "Jobs", name: "jobs" },
  ].filter((i) => i.show !== false),
);

const activeTab = computed(() => {
  const routeName = router.currentRoute.value.name?.toString();
  if (routeName != null && tabs.value.find((tab) => tab.name === routeName) != null) return routeName;
  return tabs.value[0].name;
});
</script>
<template>
  <TabsRoot class="tw-contents" :model-value="activeTab">
    <Teleport :to="headerRef">
      <TabsList class="tw-flex tw-flex-1 tw-items-center tw-justify-end">
        <TabsIndicator
          class="tw-absolute tw-left-0 tw-top-0 tw-h-1 tw-w-[--reka-tabs-indicator-size] tw-translate-x-[--reka-tabs-indicator-position] tw-transition-[width,transform] tw-duration-300"
        >
          <div class="tw-size-full tw-bg-white" />
        </TabsIndicator>
        <template v-for="tab in tabs" :key="tab.title">
          <TabsTrigger as-child :value="tab.name">
            <router-link
              :to="{ name: tab.name, params: { brand: brand } }"
              class="tw-px-2.5 tw-text-sm tw-font-semibold"
            >
              {{ tab.title }}
            </router-link>
          </TabsTrigger>
        </template>
      </TabsList>
    </Teleport>
    <TabsContent v-for="tab in tabs" :key="tab.title" :value="tab.name" class="tw-size-full">
      <router-view />
    </TabsContent>
  </TabsRoot>
</template>
